<template>
  <div>
    <Modal
      :show="showModal"
      @confirmSelected="endSale"
      @cancelSelected="$emit('closeModal')"
    >
      <template #header> {{ t("CANCEL_SALE_MODAL_HEADER") }} </template>
      <template #body>{{ t("CANCEL_SALE_MODAL_BODY") }}</template>
      <template #confirm> {{ t("CONFIRM") }} </template>
    </Modal>
  </div>
</template>
<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import { datadogRum } from "@datadog/browser-rum";
import Modal from "@/apps/merchant3/shared-components/ui/Modal.vue";
import { RoutesPageSteps } from "@/apps/merchant3/router/RoutesPageSteps";
import { CancellationReason } from "@/apps/merchant3/types/CancellationReason";
import { cancelCartAndClearStore } from "@/apps/merchant3/helpers/cancelCart.helper";
import { clearStoreAndNavigateHome } from "@/apps/merchant3/helpers/redirect.helper";

const { t } = useI18n();
const store = useStore();
const props = defineProps({
  show: {
    default: false,
    type: Boolean,
  },
  autoRedirection: {
    default: true,
    type: Boolean,
  },
});

const showModal = ref(props.show);

const step = computed(() => {
  return store.state.carts?.step || null;
});

const endSale = () => {
  // Track custom action for RUM.
  // Adding to keep track of explicit cart cancellation.
  datadogRum.addAction("m3-cancel-sale-confirmation-clicked", {
    cartTag: store.state.carts?.cartTag,
  });

  store.dispatch("sale/setSaleState", {
    saleTerminatedByClerk: true,
  });

  if (
    step.value !== RoutesPageSteps.Receipt &&
    step.value !== RoutesPageSteps.Welcome &&
    step.value !== RoutesPageSteps.MerchantLogin &&
    step.value !== RoutesPageSteps.ClerkLogin
    //&& props.autoRedirection == true
  ) {
    cancelCartAndClearStore(CancellationReason.SALE_EXPLICITLY_CANCELED);
  } else {
    clearStoreAndNavigateHome();
  }
};

watch(
  () => props.show,
  (show) => {
    showModal.value = show;
  }
);
</script>
<style lang="scss" scoped></style>
